<script setup lang="ts">

import { formatValue } from '@/utils/helpers';

type Props = {
    nftPrice: AppWTFNftPrice;
    counter: number;
};
const props = defineProps<Props>();

const formattedPriceUsd = computed(() => formatValue(
    props.nftPrice.amountUsd * props.counter,
    { precision: 2 }
));
const formattedPrice = computed(() => formatValue(
    props.nftPrice.amount * props.counter,
    { precision: 6 }
));
</script>

<template>
  <div class="display-flex align-items-center gap-8 flex-wrap"
  >
    <div class="display-flex gap-8 align-items-center">
      <div class="wallet-icon display-flex align-items-center justify-center">
        <ImgMain v-if="nftPrice.logo"
                 :alt="nftPrice.token"
                 :src="nftPrice.logo"
                 :width="28"
                 :height="28"
        />
        <IconTypes v-else
                   :size="25"
                   name="logo/etherium"
        />
      </div>

      <p class="display-900-accent-numeric">
        {{ formattedPrice }}
      </p>
    </div>

    <p class="compact-700-numeric color-text-grey">
      ~${{ formattedPriceUsd }}
    </p>
  </div>
</template>
<style scoped lang="scss">
.wallet-icon {
  min-width: var(--control-300-size-single, 28px);
  height: var(--control-300-size-single, 28px);
  border-radius: var(--radius-999, 999px);
}
</style>
